import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['igForm', 'operaForm', 'pmsType', 'operaKioskForm']

  connect() {
    this.onPMSTypeChanged()
  }

  onPMSTypeChanged = () => {
    this.hidePMSForms();
    if (this.pmsTypeTarget.value === 'infogenesis') {
      this.igFormTarget.classList.remove('hidden')
    }

    if (this.pmsTypeTarget.value === 'opera') {
      this.operaFormTarget.classList.remove('hidden')
    }

    if (this.pmsTypeTarget.value === 'opera_kiosk') {
      this.operaKioskFormTarget.classList.remove('hidden')
    }
  }

  hidePMSForms() {
    this.igFormTarget.classList.add('hidden');
    this.operaFormTarget.classList.add('hidden');
    this.operaKioskFormTarget.classList.add('hidden')
  }
}
